import dayjs from "dayjs";
import { defineStore } from "pinia";

export interface NotificationItem {
  id: string | number;
  type: string;
  data: any;
  read_at?: number;
  created_at: number;
}

interface NotificationState {
  page: number;
  unreadCount: number; // unread unreadCount
  items: NotificationItem[];
}

export const useNotificationStore = defineStore("notification", {
  state: (): NotificationState => ({
    page: 1,
    unreadCount: 0,
    items: [],
  }),
  actions: {
    setUnreadCount(value: number) {
      if (isNaN(value)) {
        value = 0;
      }

      this.unreadCount = value > 99 ? 99 : value;
    },
    setPage(value: number) {
      this.page = value;
    },
    setItems(value: NotificationItem[]) {
      this.items = value;
    },
    updateItem(item: NotificationItem) {
      const index = this.items.findIndex((it) => it.id === item.id);

      if (index !== -1) {
        this.items = [...this.items.slice(0, index), item, ...this.items.slice(index + 1)];
      }
    },
    pushItem(value: NotificationItem) {
      this.items.push(value);
    },
    unshiftItem(value: NotificationItem) {
      this.items.unshift(value);
    },
    read(item: NotificationItem) {
      const index = this.items.findIndex((it) => it.id === item.id);

      if (index !== -1) {
        this.items = [
          ...this.items.slice(0, index),
          {
            ...this.items[index],
            read_at: dayjs().unix(),
          },
          ...this.items.slice(index + 1),
        ];
      }

      this.setUnreadCount(this.unreadCount - 1);
    },
    readAll() {
      this.items = this.items.map((item) => ({ ...item, read_at: dayjs().unix() }));
      this.setUnreadCount(0);
    },
    clearItems() {
      this.items = [];
    },
    reset() {
      this.page = 0;
      this.unreadCount = 0;
      this.items = [];
    },
  },
  getters: {},
});
